var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout-gestao", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "form",
          {
            attrs: {
              autocomplete: "off",
              method: "post",
              "data-vv-scope": "form",
            },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return (() => {}).apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-sm-auto" }, [
                _c("h1", { staticClass: "content-title" }, [
                  _vm._v(_vm._s(_vm.titleItem)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("nav", [
              _c(
                "div",
                {
                  staticClass: "nav nav-tabs nav-fill mb-3 sky-blue",
                  attrs: { id: "nav-tab", role: "tablist" },
                },
                _vm._l(_vm.tabs, function (tab, idx) {
                  return _c(
                    "a",
                    {
                      key: `tab-${tab["name"]}`,
                      staticClass: "nav-item nav-link",
                      class: { active: _vm.localActive == tab },
                      attrs: {
                        href: `#${tab["code"]}`,
                        "data-toggle": "tab",
                        role: "tab",
                        "aria-selected": _vm.localActive == tab,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.localActive = tab
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(tab["name"]) +
                          "\n                        "
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tab-content", attrs: { id: "nav-tabContent" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "show active": _vm.localActive == _vm.tabs[0] },
                    attrs: {
                      id: "nav-general",
                      role: "tabpanel",
                      "aria-labelledby": "nav-general-tab",
                    },
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-12" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "MaterialSelect",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                staticClass: "city-form-group city-bg",
                                attrs: {
                                  disabled: _vm.readonlyFormItem,
                                  id: "input-entity_id",
                                  name: "entity_id",
                                  label: "name",
                                  filterable: true,
                                  options: _vm.lists.entities,
                                  inputClasses: [
                                    {
                                      "is-invalid": _vm.fnHasError("entity_id"),
                                    },
                                  ],
                                  error: _vm.fnFirstError("entity_id"),
                                  helpText: _vm.$t(`${_vm.pageID}.help.entity`),
                                },
                                model: {
                                  value: _vm.form.entity_id,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "entity_id",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.entity_id",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(
                                      _vm.$t(`${_vm.pageID}.model.entity`)
                                    ) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-7" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "MaterialInput",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|min:3",
                                    expression: "'required|min:3'",
                                  },
                                ],
                                staticClass: "city-form-group city-bg",
                                attrs: {
                                  readonly: _vm.readonlyFormItem,
                                  type: "text",
                                  id: "input-name",
                                  name: "name",
                                  inputClasses: [
                                    { "is-invalid": _vm.fnHasError("name") },
                                  ],
                                  error: _vm.fnFirstError("name"),
                                },
                                model: {
                                  value: _vm.form.name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "name",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.name",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(_vm.$t(`${_vm.pageID}.model.name`)) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-5" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "MaterialInput",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "min:3",
                                    expression: "'min:3'",
                                  },
                                ],
                                staticClass: "city-form-group city-bg",
                                attrs: {
                                  readonly: _vm.readonlyFormItem,
                                  type: "text",
                                  id: "input-address",
                                  name: "address",
                                  inputClasses: [
                                    { "is-invalid": _vm.fnHasError("address") },
                                  ],
                                  error: _vm.fnFirstError("address"),
                                },
                                model: {
                                  value: _vm.form.address,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "address",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.address",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(
                                      _vm.$t(`${_vm.pageID}.model.address`)
                                    ) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-6 col-lg-5" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "MaterialInput",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "emails",
                                    expression: "'emails'",
                                  },
                                ],
                                staticClass: "city-form-group city-bg",
                                attrs: {
                                  readonly: _vm.readonlyFormItem,
                                  type: "email",
                                  id: "input-email",
                                  name: "email",
                                  inputClasses: [
                                    { "is-invalid": _vm.fnHasError("email") },
                                  ],
                                  error: _vm.fnFirstError("email"),
                                  helpText: _vm.$t(`${_vm.pageID}.help.email`),
                                },
                                model: {
                                  value: _vm.form.email,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "email",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.email",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(
                                      _vm.$t(`${_vm.pageID}.model.email`)
                                    ) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-6 col-lg-4" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "MaterialInput",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "phones",
                                    expression: "'phones'",
                                  },
                                ],
                                staticClass: "city-form-group city-bg",
                                attrs: {
                                  readonly: _vm.readonlyFormItem,
                                  type: "text",
                                  id: "input-phone",
                                  name: "phone",
                                  inputClasses: [
                                    { "is-invalid": _vm.fnHasError("phone") },
                                  ],
                                  error: _vm.fnFirstError("phone"),
                                  helpText: _vm.$t(`${_vm.pageID}.help.phone`),
                                },
                                model: {
                                  value: _vm.form.phone,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "phone",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.phone",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(
                                      _vm.$t(`${_vm.pageID}.model.phone`)
                                    ) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-4 col-lg-3" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "MaterialInput",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "integer|min_value:1",
                                    expression: "'integer|min_value:1'",
                                  },
                                ],
                                staticClass: "city-form-group city-bg",
                                attrs: {
                                  readonly: _vm.readonlyFormItem,
                                  type: "number",
                                  id: "input-n_operational",
                                  name: "n_operational",
                                  inputClasses: [
                                    {
                                      "is-invalid":
                                        _vm.fnHasError("n_operational"),
                                    },
                                  ],
                                  error: _vm.fnFirstError("n_operational"),
                                  helpText: _vm.$t(
                                    `${_vm.pageID}.help.n_operational`
                                  ),
                                },
                                model: {
                                  value: _vm.form.n_operational,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "n_operational",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.n_operational",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(
                                      _vm.$t(
                                        `${_vm.pageID}.model.n_operational`
                                      )
                                    ) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-4" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "MaterialInput",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { lat: { checkDMS: true } },
                                    expression: "{ lat: { checkDMS: true } }",
                                  },
                                ],
                                staticClass: "city-form-group city-bg",
                                attrs: {
                                  readonly: _vm.readonlyFormItem,
                                  type: "text",
                                  id: "input-lat",
                                  name: "lat",
                                  inputClasses: [
                                    { "is-invalid": _vm.fnHasError("lat") },
                                  ],
                                  error: _vm.fnFirstError("lat"),
                                  helpText: _vm.$t(`${_vm.pageID}.help.lat`),
                                },
                                model: {
                                  value: _vm.form.lat,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "lat",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.lat",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(_vm.$t(`${_vm.pageID}.model.lat`)) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-4" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "MaterialInput",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { lng: { checkDMS: true } },
                                    expression: "{ lng: { checkDMS: true } }",
                                  },
                                ],
                                staticClass: "city-form-group city-bg",
                                attrs: {
                                  readonly: _vm.readonlyFormItem,
                                  type: "text",
                                  id: "input-lng",
                                  name: "lng",
                                  inputClasses: [
                                    { "is-invalid": _vm.fnHasError("lng") },
                                  ],
                                  error: _vm.fnFirstError("lng"),
                                  helpText: _vm.$t(`${_vm.pageID}.help.lng`),
                                },
                                model: {
                                  value: _vm.form.lng,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "lng",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.lng",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(_vm.$t(`${_vm.pageID}.model.lng`)) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "form-group city-form-group city-bg mb-0",
                          },
                          [
                            _c(
                              "MaterialTextarea",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "min:3",
                                    expression: "'min:3'",
                                  },
                                ],
                                staticClass: "city-form-group city-bg",
                                attrs: {
                                  disabled: _vm.readonlyFormItem,
                                  rows: 4,
                                  id: "input-skills",
                                  name: "skills",
                                  inputClasses: [
                                    { "is-invalid": _vm.fnHasError("skills") },
                                  ],
                                  error: _vm.fnFirstError("skills"),
                                },
                                model: {
                                  value: _vm.form.skills,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "skills",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.skills",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(
                                      _vm.$t(`${_vm.pageID}.model.skills`)
                                    ) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("upload-multiple-file", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "",
                                expression: "''",
                              },
                            ],
                            attrs: {
                              disabled: _vm.readonlyFormItem,
                              acceptTypes: _vm.acceptTypes,
                              maxFiles: _vm.maxFiles,
                              name: "files",
                            },
                            model: {
                              value: _vm.form.files,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "files", $$v)
                              },
                              expression: "form.files",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "show active": _vm.localActive == _vm.tabs[1] },
                    attrs: {
                      id: "nav-types",
                      role: "tabpanel",
                      "aria-labelledby": "nav-types-tab",
                    },
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c("types-list", {
                            directives: [
                              { name: "validate", rawName: "v-validate" },
                            ],
                            attrs: {
                              moduleId: _vm.moduleCode,
                              readonlyFormItem: _vm.readonlyFormItem,
                              data: _vm.families,
                            },
                            model: {
                              value: _vm.form.types,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "types", $$v)
                              },
                              expression: "form.types",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "show active": _vm.localActive == _vm.tabs[2] },
                    attrs: {
                      id: "nav-agents",
                      role: "tabpanel",
                      "aria-labelledby": "nav-agents-tab",
                    },
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12" },
                        [
                          _vm.loaded
                            ? _c("table-data", {
                                directives: [
                                  { name: "validate", rawName: "v-validate" },
                                ],
                                attrs: {
                                  route: _vm.tableHumanMeans.url,
                                  settings: _vm.tableHumanMeans.settings,
                                  columns: _vm.tableHumanMeans.columns,
                                  inlineFilters: _vm.tableHumanMeans.filters,
                                  autoUpdateFilter:
                                    _vm.tableHumanMeans.autoUpdateFilter,
                                  addParamsToUrl:
                                    _vm.tableHumanMeans.addParamsToUrl,
                                  loadingMsg: _vm.tableHumanMeans.loadingMsg,
                                  noDataMsg: _vm.tableHumanMeans.notFoundMsg,
                                  orderByTemplate:
                                    _vm.tableHumanMeans.orderByTemplate,
                                  showPagination:
                                    _vm.tableHumanMeans.showPagination,
                                  tableInline: _vm.tableHumanMeans.tableInline,
                                  name: "agents",
                                },
                                on: { "error-load": _vm.showError },
                                scopedSlots: _vm._u(
                                  [
                                    !_vm.readonlyFormItem
                                      ? {
                                          key: "title",
                                          fn: function ({ add }) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-12" },
                                                    [
                                                      _c("MaterialSelect", {
                                                        staticClass:
                                                          "city-form-group city-bg",
                                                        attrs: {
                                                          size: "small",
                                                          label:
                                                            _vm.tableHumanMeans
                                                              .label,
                                                          placeholder:
                                                            _vm.tableHumanMeans
                                                              .placeholder,
                                                          ajaxOptions: {
                                                            url: _vm
                                                              .tableHumanMeans
                                                              .urlSearch,
                                                          },
                                                          reduce: (option) =>
                                                            option,
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "option",
                                                              fn: function ({
                                                                option,
                                                              }) {
                                                                return [
                                                                  _c("div", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.tableHumanMeans.funcItemHtml(
                                                                            option
                                                                          )
                                                                        ),
                                                                    },
                                                                  }),
                                                                ]
                                                              },
                                                            },
                                                            {
                                                              key: "grpAppend",
                                                              fn: function () {
                                                                return [
                                                                  _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "btn btn-main",
                                                                      attrs: {
                                                                        disabled:
                                                                          !_vm.agent,
                                                                        type: "button",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.preventDefault()
                                                                            return _vm.addItem(
                                                                              "agent",
                                                                              add
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                            " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .tableHumanMeans
                                                                              .addTitle
                                                                          ) +
                                                                          "\n                                                        "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                        model: {
                                                          value: _vm.agent,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.agent = $$v
                                                          },
                                                          expression: "agent",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        }
                                      : null,
                                    {
                                      key: "body",
                                      fn: function ({
                                        columns,
                                        row,
                                        index,
                                        remove,
                                      }) {
                                        return [
                                          _c(
                                            "td",
                                            { class: columns[0].class },
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    target: "_blank",
                                                    to: {
                                                      name: `${_vm.userModuleCode}.${_vm.userPageID}.show`,
                                                      params: { id: row.id },
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.columnValue(
                                                          row,
                                                          columns[0]
                                                        )
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { class: columns[1].class },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.columnValue(
                                                      row,
                                                      columns[1]
                                                    )
                                                  ) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { class: columns[2].class },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.columnValue(
                                                      row,
                                                      columns[2]
                                                    )
                                                  ) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.checkActions
                                            ? _c("column-actions", {
                                                attrs: {
                                                  deleteMsgTemplate: `${_vm.pageID}.list.agent.deleteMsg`,
                                                  label: columns[0].field,
                                                  canDetail: false,
                                                  canEdit: false,
                                                  canDelete: _vm.canDelete,
                                                  row: row,
                                                  index: index,
                                                },
                                                on: {
                                                  delete: (id) =>
                                                    _vm.removeItem(
                                                      id,
                                                      "agent",
                                                      remove
                                                    ),
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "show active": _vm.localActive == _vm.tabs[3] },
                    attrs: {
                      id: "nav-materials",
                      role: "tabpanel",
                      "aria-labelledby": "nav-materials-tab",
                    },
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("h6", { staticClass: "font-weight-normal" }, [
                          _vm._v(
                            _vm._s(_vm.$t(`${_vm.pageID}.model.vehicles`))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("hr", { staticClass: "mt-2" }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12" },
                        [
                          _vm.loaded
                            ? _c("table-data", {
                                directives: [
                                  { name: "validate", rawName: "v-validate" },
                                ],
                                attrs: {
                                  route: _vm.tableVehicles.url,
                                  settings: _vm.tableVehicles.settings,
                                  columns: _vm.tableVehicles.columns,
                                  inlineFilters: _vm.tableVehicles.filters,
                                  autoUpdateFilter:
                                    _vm.tableVehicles.autoUpdateFilter,
                                  addParamsToUrl:
                                    _vm.tableVehicles.addParamsToUrl,
                                  loadingMsg: _vm.tableVehicles.loadingMsg,
                                  noDataMsg: _vm.tableVehicles.notFoundMsg,
                                  orderByTemplate:
                                    _vm.tableVehicles.orderByTemplate,
                                  showPagination:
                                    _vm.tableVehicles.showPagination,
                                  tableInline: _vm.tableVehicles.tableInline,
                                  name: "vehicles",
                                },
                                on: { "error-load": _vm.showError },
                                scopedSlots: _vm._u(
                                  [
                                    !_vm.readonlyFormItem
                                      ? {
                                          key: "title",
                                          fn: function ({ add }) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-12" },
                                                    [
                                                      _c("MaterialSelect", {
                                                        staticClass:
                                                          "city-form-group city-bg",
                                                        attrs: {
                                                          size: "small",
                                                          label:
                                                            _vm.tableVehicles
                                                              .label,
                                                          placeholder:
                                                            _vm.tableVehicles
                                                              .placeholder,
                                                          ajaxOptions: {
                                                            url: _vm
                                                              .tableVehicles
                                                              .urlSearch,
                                                          },
                                                          reduce: (option) =>
                                                            option,
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "option",
                                                              fn: function ({
                                                                option,
                                                              }) {
                                                                return [
                                                                  _c("div", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.tableVehicles.funcItemHtml(
                                                                            option
                                                                          )
                                                                        ),
                                                                    },
                                                                  }),
                                                                ]
                                                              },
                                                            },
                                                            {
                                                              key: "grpAppend",
                                                              fn: function () {
                                                                return [
                                                                  _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "btn btn-main",
                                                                      attrs: {
                                                                        disabled:
                                                                          !_vm.vehicle,
                                                                        type: "button",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.preventDefault()
                                                                            return _vm.addItem(
                                                                              "vehicle",
                                                                              add
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                            " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .tableVehicles
                                                                              .addTitle
                                                                          ) +
                                                                          "\n                                                        "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                        model: {
                                                          value: _vm.vehicle,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.vehicle = $$v
                                                          },
                                                          expression: "vehicle",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        }
                                      : null,
                                    {
                                      key: "body",
                                      fn: function ({
                                        columns,
                                        row,
                                        index,
                                        remove,
                                      }) {
                                        return [
                                          _c(
                                            "td",
                                            { class: columns[0].class },
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    target: "_blank",
                                                    to: {
                                                      name: `${_vm.vehicleModuleCode}.${_vm.vehiclePageID}.show`,
                                                      params: { id: row.id },
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.columnValue(
                                                          row,
                                                          columns[0]
                                                        )
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("h6", { staticClass: "font-weight-normal" }, [
                          _vm._v(_vm._s(_vm.$t(`${_vm.pageID}.model.radios`))),
                        ]),
                        _vm._v(" "),
                        _c("hr", { staticClass: "mt-2" }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12" },
                        [
                          _vm.loaded
                            ? _c("table-data", {
                                directives: [
                                  { name: "validate", rawName: "v-validate" },
                                ],
                                attrs: {
                                  route: _vm.tableRadios.url,
                                  settings: _vm.tableRadios.settings,
                                  columns: _vm.tableRadios.columns,
                                  inlineFilters: _vm.tableRadios.filters,
                                  autoUpdateFilter:
                                    _vm.tableRadios.autoUpdateFilter,
                                  addParamsToUrl:
                                    _vm.tableRadios.addParamsToUrl,
                                  loadingMsg: _vm.tableRadios.loadingMsg,
                                  noDataMsg: _vm.tableRadios.notFoundMsg,
                                  orderByTemplate:
                                    _vm.tableRadios.orderByTemplate,
                                  showPagination:
                                    _vm.tableRadios.showPagination,
                                  tableInline: _vm.tableRadios.tableInline,
                                  name: "radios",
                                },
                                on: { "error-load": _vm.showError },
                                scopedSlots: _vm._u(
                                  [
                                    !_vm.readonlyFormItem
                                      ? {
                                          key: "title",
                                          fn: function ({ add }) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-12" },
                                                    [
                                                      _c("MaterialSelect", {
                                                        staticClass:
                                                          "city-form-group city-bg",
                                                        attrs: {
                                                          size: "small",
                                                          minLen: 1,
                                                          label:
                                                            _vm.tableRadios
                                                              .label,
                                                          placeholder:
                                                            _vm.tableRadios
                                                              .placeholder,
                                                          ajaxOptions: {
                                                            url: _vm.tableRadios
                                                              .urlSearch,
                                                          },
                                                          reduce: (option) =>
                                                            option,
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "option",
                                                              fn: function ({
                                                                option,
                                                              }) {
                                                                return [
                                                                  _c("div", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.tableRadios.funcItemHtml(
                                                                            option
                                                                          )
                                                                        ),
                                                                    },
                                                                  }),
                                                                ]
                                                              },
                                                            },
                                                            {
                                                              key: "grpAppend",
                                                              fn: function () {
                                                                return [
                                                                  _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "btn btn-main",
                                                                      attrs: {
                                                                        disabled:
                                                                          !_vm.agent,
                                                                        type: "button",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.preventDefault()
                                                                            return _vm.addItem(
                                                                              "radio",
                                                                              add
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                            " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .tableRadios
                                                                              .addTitle
                                                                          ) +
                                                                          "\n                                                        "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                        model: {
                                                          value: _vm.radio,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.radio = $$v
                                                          },
                                                          expression: "radio",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        }
                                      : null,
                                    {
                                      key: "body",
                                      fn: function ({ columns, row }) {
                                        return [
                                          _c(
                                            "td",
                                            { class: columns[0].class },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.columnValue(
                                                      row,
                                                      columns[0]
                                                    )
                                                  ) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { class: columns[1].class },
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    target: "_blank",
                                                    to: {
                                                      name: `${_vm.radioModuleCode}.${_vm.radioPageID}.show`,
                                                      params: { id: row.id },
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.columnValue(
                                                          row,
                                                          columns[1]
                                                        )
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("buttons-footer", {
              attrs: {
                enableButtons: !_vm.readonlyFormItem,
                cancelTitle: _vm.cancelTitle,
                submitTitle: _vm.submitTitle,
                isDisabled: _vm.isDisabled,
              },
              on: {
                save: _vm.onSaveItem,
                cancel: function ($event) {
                  return _vm.handleBack(`${_vm.moduleCode}.${_vm.pageID}`)
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }